export default __webpack_public_path__ + "static/media/qr-code_scissor_sister.2e7d1370.png";